import { render, staticRenderFns } from "./DiscountLabel.vue?vue&type=template&id=8af158ba&scoped=true&"
import script from "./DiscountLabel.vue?vue&type=script&lang=js&"
export * from "./DiscountLabel.vue?vue&type=script&lang=js&"
import style0 from "./DiscountLabel.scss?vue&type=style&index=0&id=8af158ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af158ba",
  null
  
)

export default component.exports